document.addEventListener('DOMContentLoaded', function () {
    // Simple Intersection Observer for Fade-In Animation
    const observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
            if (entry.isIntersecting) {
                entry.target.classList.add('visible');
            }
        });
    }, { threshold: 0.1 });

    document.querySelectorAll('.fade-in').forEach(el => observer.observe(el));

    // Simple Accordion
    document.querySelectorAll('.accordion-trigger').forEach(trigger => {
        trigger.addEventListener('click', () => {
            const item = trigger.parentElement;
            item.classList.toggle('active');
        });
    });

    // Cookie Banner Logic
    const banner = document.getElementById('cookie-banner');
    const acceptBtn = document.getElementById('accept-cookies');

    if (banner && acceptBtn) {
        if (!localStorage.getItem('cookies-accepted')) {
            banner.style.display = 'block';
        }

        acceptBtn.addEventListener('click', function () {
            localStorage.setItem('cookies-accepted', 'true');
            banner.style.display = 'none';
        });
    }
});

// Legal Modal Logic
function openLegal(type) {
    const modal = document.getElementById('legal-modal');
    const content = document.getElementById('legal-modal-body');

    if (type === 'impressum') {
        content.innerHTML = `
            <h3>Impressum</h3>
            <p><strong>Angaben gemäß § 5 TMG:</strong></p>
            <p>Phil Hüpen<br>Pastor-hahnen Strasse 4<br>47638 Straelen</p>
            <p><strong>Kontakt:</strong><br>Telefon: +49 1523 4674840<br>E-Mail: phil-huepen@gmx.de</p>
        `;
    } else if (type === 'datenschutz') {
        content.innerHTML = `
            <h3>Datenschutzerklärung</h3>
            <p>Verantwortlicher im Sinne der Datenschutzgesetze ist:<br>Phil Hüpen</p>
            <p><strong>Kontakt:</strong><br>Pastor-hahnen Strasse 4<br>47638 Straelen<br>E-Mail: phil-huepen@gmx.de</p>
            <p>Wir erheben keine personenbezogenen Daten auf dieser statischen Vorschauseite, außer der Speicherung Ihres Cookie-Einverständnisses in Ihrem Browser (LocalStorage).</p>
        `;
    }

    if (modal) {
        modal.style.display = 'flex';
        document.body.style.overflow = 'hidden';
    }
}

function closeLegal() {
    const modal = document.getElementById('legal-modal');
    if (modal) {
        modal.style.display = 'none';
        document.body.style.overflow = 'auto';
    }
}

// Close on outside click
window.onclick = function (event) {
    const modal = document.getElementById('legal-modal');
    if (event.target == modal) {
        closeLegal();
    }
}
